import * as React from "react";
import {RemoveItemsList} from "../RemoveItemsList/RemoveItemsList";
import Text, {TextInput} from "../form/Text/Text";
import ActionButton from "../Button/ActionButton";
import BoundField from "../form/BoundField/BoundField";
import {BoundFieldProps} from "../Actions/pluginRegistry";
import styles = require("./style.less");

class KeyValueRemoveItemsList extends RemoveItemsList<{key: string, value: string}> { }
const noop = (): any => undefined;
interface SomethingProps {
    items: string;
    name: string;
    keyLabel: string;
    keyHintText?: string;
    valueLabel: string;
    valueHintText?: string;
    reverseLayout?: boolean;
    separator: string;
    onChange(items: string): void;
}

interface SomethingState {
    source: Array<{key: string, value: string}>;
}

export default class KeyValueEditList extends React.PureComponent<SomethingProps & BoundFieldProps, SomethingState> {
    adding = false;

    constructor(props: SomethingProps & BoundFieldProps) {
        super(props);
        this.state = {
            source: []
        };
    }

    componentDidMount() {
        this.setInternalState(this.props);
    }

    setInternalState(props: SomethingProps) {
        try {
            const source = JSON.parse(this.props.items || "{}");
            this.setState({
                source: Object.keys(source).reduce((arr, key) => {
                    arr.push({key, value: source[key]});
                    return arr;
                }, [])
            });
        } catch (e) {
            this.setState({source: []});
        }
    }

    handleRemoveRow = (item: any) => {
        const data = this.state.source;
        data.splice(data.indexOf(item), 1);
        this.invokeOnChange(data);
    }

    handleRowRef = (idx: number) => (input: TextInput | null) => {
        if (input && this.adding && idx === 0) {
            input.focus();
            this.adding = false;
        }
    }

    handleKeyChange = (idx: number) => (val: any) => {
        const data = this.state.source;
        data[idx].key = val;
        this.invokeOnChange(data);
    }

    handleValueChange = (idx: number) => (val: any) => {
        const data = this.state.source;
        data[idx].value = val;
        this.invokeOnChange(data);
    }

    invokeOnChange = (data: any) => {
        const values = this.state.source.reduce((idx: any, item) => {
            idx[item.key] = item.value;
            return idx;
        }, {});
        this.props.onChange(JSON.stringify(values));
    }

    handleAddClick = () => {
        const data = this.state.source;
        this.adding = true;
        this.setState({source: [{key: "", value: ""}, ...data]});
    }

    renderRow = (item: any, idx: number) => {
        let fields = [<div className={styles.textControl} key="key">
            <BoundField localNames={this.props.localNames}
                        resetValue={""}
                        projectId={this.props.projectId}>
                <Text textInputRef={this.props.reverseLayout ? noop : this.handleRowRef(idx)}
                      value={item.key}
                      onChange={this.handleKeyChange(idx)}
                      label={this.props.keyLabel}
                      hintText={this.props.keyHintText}/>
            </BoundField>
        </div>,
            <span className={styles.separator} key="seperator">{this.props.separator}</span>,
            <div className={styles.textControl} key="value">
                <BoundField localNames={this.props.localNames}
                            resetValue={""}
                            projectId={this.props.projectId}
                            key="value">
                    <Text textInputRef={this.props.reverseLayout ? this.handleRowRef(idx) : noop}
                          value={item.value}
                          onChange={this.handleValueChange(idx)}
                          label={this.props.valueLabel}
                          hintText={this.props.valueHintText}/>
                </BoundField>
            </div>];

        if (this.props.reverseLayout) {
            fields = fields.reverse();
        }

        return <div key={"KVI-" + idx} className={styles.itemContainer}>
            {fields}
        </div>;
    }

    render() {
        const actionButton = <ActionButton key="Add"
                                           label={`Add ${this.props.name}`}
                                           onClick={this.handleAddClick}/>;
        return <KeyValueRemoveItemsList listActions={[actionButton]}
                                        data={this.state.source}
                                        onRemoveRow={this.handleRemoveRow}
                                        onRow={this.renderRow}
                                        clearButtonToolTip={`Remove ${this.props.name}`}/>;
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/components/EditList/KeyValueEditList.tsx